export default __webpack_public_path__ + "static/media/005-arrow-down-dashed.a5bf1714.svg";